import { getPrimaryOpaqueColor, Modal, ModalProps } from '@orcar/common-d2c';
import styled from 'styled-components';
import { app } from '@/constants/common';
import { INSURANCE_INFO, INSURANCE_RANGE } from '@/constants/insurance';

const InsuranceInfoModal = ({ onClose }: Pick<ModalProps, 'onClose'>) => {
  const INSURANCES = INSURANCE_RANGE.map((item) => item.insurance);
  return (
    <Modal
      onClose={onClose}
      paddingHorizontal={70}
      paddingVertical={30}
      topLevel
    >
      <Wrapper>
        <TitleText>자차 보험 안내</TitleText>
        <TableWrapper>
          <TableHeaderWrapper>
            <tr>
              <TableHeader rowSpan={2} first>
                구분
              </TableHeader>
              {INSURANCE_RANGE.map((item, idx) => (
                <TableItem key={idx}>{item.info}</TableItem>
              ))}
            </tr>
            <tr>
              {INSURANCES.map((item, idx) => (
                <TableHeader key={idx}>{item}</TableHeader>
              ))}
            </tr>
          </TableHeaderWrapper>
          <tbody>
            {INSURANCE_INFO.map((table, idx) => (
              <tr key={idx}>
                <TableItem>
                  {table.title}
                  {table.subs.map((sub, idx) => (
                    <SubText key={idx}>{sub}</SubText>
                  ))}
                </TableItem>
                {table.items.map((item, idx) => (
                  <TableItem key={idx}>{item}</TableItem>
                ))}
              </tr>
            ))}
          </tbody>
        </TableWrapper>
      </Wrapper>
    </Modal>
  );
};

export default InsuranceInfoModal;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 1023px;
`;

const TitleText = styled.p`
  ${({ theme }) => theme.FONT.H4};
`;

const TableWrapper = styled.table`
  width: 100%;
  margin: 40px 0 10px;
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_01};
  border-collapse: collapse;
`;

const TableHeaderWrapper = styled.thead`
  background-color: ${getPrimaryOpaqueColor(app, true)};
`;
const TableHeader = styled.th<{ first?: boolean }>`
  padding: 9px 0;
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_01};
  color: ${({ theme }) => theme.COLOR.GREY_01};
  ${({ theme }) => theme.FONT.B1};
  font-weight: 600;

  min-width: ${({ first }) => first && '277px'};
`;

const TableItem = styled.td`
  width: 247px;
  padding: 14px 0;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_01};
  ${({ theme }) => theme.FONT.B2};
  color: ${({ theme }) => theme.COLOR.GREY_01};
  white-space: pre-wrap;
`;

const SubText = styled.p`
  ${({ theme }) => theme.FONT.B3};
  color: ${({ theme }) => theme.COLOR.GREY_02};
`;
